/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

// Named re-exports throughout (no `export *`) so future file-level exports
// inside any of these modules don't auto-widen the package's public API
// surface — widening requires an explicit addition here.
export { cosmosPageDirectoryMetadata } from "./CosmosPageDirectory.data";
export { CosmosPageDirectoryPage, getPageDirectory } from "./CosmosPageDirectory.page";
export { CosmosPageDirectoryClient } from "./CosmosPageDirectoryClient";

// `DirectoryCmsBody` runtime + props + `Data` union re-exported for Storybook
// and test composition. The chrome shapes (`DirectoryBaseChrome` /
// `DirectoryServiceChrome`) stay internal — they're a private translation
// seam between `CosmosPageDirectoryClient` and the CMS-body component, not
// a public API.
export { DirectoryCmsBody } from "./DirectoryCmsBody";
export type { DirectoryCmsBodyData, DirectoryCmsBodyProps } from "./DirectoryCmsBody";

export { InstructorSpotlight } from "./InstructorSpotlight";
export type { InstructorSpotlightProps } from "./InstructorSpotlight";

export { InstructorCard } from "./cards/InstructorCard";
export type { InstructorCardProps } from "./cards/InstructorCard";
export { TrainingPartnerCard } from "./cards/TrainingPartnerCard";
export type { TrainingPartnerCardProps } from "./cards/TrainingPartnerCard";
export { ServicePartnerCard } from "./cards/ServicePartnerCard";
export type { ServicePartnerCardProps } from "./cards/ServicePartnerCard";
export type { ServicePartnerBadgeAssets } from "./cards/buildPartnerCardProps";

export type { DirectoryPageData, DirectoryPageDataBase } from "./types";

// Internal helpers (cosmosPageDirectoryDetails, fetchCards, buildPartnerCardProps)
// are not re-exported; they are implementation details of the page component.
